angular.module('psModule').filter('initialuppercase', function($filter) {
	return function(input) {
        if (input != null && input.length > 0) {
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
        return input;
	};
});
